import { makeStyles } from '@material-ui/core/styles'
import DeleteIcon from '@material-ui/icons/Clear'
import React, { useEffect, useState } from 'react'
import { debounce } from 'lodash'
import { Autocomplete, TextField } from '../common/FormFields'
import { FieldTypes } from '../../utils/constants'

export default function ManualEventCompanion({
  companion,
  invitations,
  handleChangeCompanion,
  handleRemoveCompanion,
  debouncedHandleInputChange,
  loading,
}) {
  const classes = useStyles()
  const [inputValue, setInputValue] = useState(companion.ci || '')

  useEffect(() => {
    if (inputValue.includes(' ')) {
      setInputValue(inputValue.replace(' ', ''))
    }
  }, [inputValue])

  const handleAutocompleteChange = (event, value) => {
    if (value) {
      handleChangeCompanion({
        ...companion,
        ci: value.ci,
        firstName: value.firstName,
        lastName: value.lastName,
        blackListed: value.blackListed,
      })
      setInputValue(value.ci)
    }
  }

  const handleInputChange = (event, newInputValue) => {
    setInputValue(newInputValue)
    if (debouncedHandleInputChange) {
      debouncedHandleInputChange(newInputValue)
    }
  }

  const handleBlur = (event) => {
    if (inputValue.trim()) {
      handleChangeCompanion({
        ...companion,
        ci: inputValue,
      })
    }
  }

  return (
    <div className={classes.container}>
      <Autocomplete
        field={{
          type: FieldTypes.Autocomplete,
          label: 'Documento de identidad',
          hint: 'Ingrese un documento',
          key: 'ci',
          options: invitations || [],
          multiple: false,
          freeSolo: true,
          filterOptions: (options) => options,
          loading,
          onChange: handleAutocompleteChange,
          inputValue: inputValue, // Controla el inputValue con el estado local
          onInputChange: handleInputChange,
          getOptionLabel: (option) =>
            `${option.ci || ''} ${
              option.blackListed ? ' - En lista negra' : ''
            }`,
          renderOption: (option) => (
            <span style={{ color: option.blackListed ? 'red' : 'white' }}>
              {`${option.firstName || ''} ${option.lastName || ''} CI: ${
                option.ci || ''
              } ${option.blackListed ? ' - En lista negra' : ''}`}
            </span>
          ),
          value: companion.ci ? companion : null,
          onBlur: handleBlur,
          withRightMargin: true,
        }}
        values={companion}
      />
      <TextField
        field={{
          type: FieldTypes.TextField,
          label: 'Nombre',
          hint: 'Ingrese el nombre',
          key: 'firstName',
          onlyLetters: true,
          withRightMargin: true,
          capitalized: true,
        }}
        values={companion}
        setValues={handleChangeCompanion}
      />
      <TextField
        field={{
          type: FieldTypes.TextField,
          label: 'Apellido',
          hint: 'Ingrese un apellido',
          key: 'lastName',
          onlyLetters: true,
          capitalized: true,
        }}
        values={companion}
        setValues={handleChangeCompanion}
      />
      <DeleteIcon
        style={{ cursor: 'pointer' }}
        className={classes.withMargin}
        onClick={handleRemoveCompanion}
      />
    </div>
  )
}

const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    alignItems: 'center',
    marginTop: '12px',
  },
  withMargin: {
    margin: '27px 0 20px 8px',
  },
}))
